import styled from 'styled-components';
import BackHeader from '../shared/components/BackHeader';
import {EvidenceData} from '../data/evidence';
import {NavLink, Route, Switch} from 'react-router-dom';
import {gray600, gray900} from '../shared/themes/color';
import UxSection from './sections/UxSection';
import AllWorksSection from './sections/AllWorksSection';
import ContentFluid from '../shared/components/ContentFluid';
import CreativeSection from './sections/CreativeSection';
import BrandingSection from './sections/BrandingSection';
import FrontSection from './sections/FrontSection';

const UxData = EvidenceData;

const NavContainer = styled.div`
  margin: 2.5rem 12rem 0 12rem;

  @media (max-width: 800px) {
    margin: 2.5rem 6rem 0 6rem;
  }

  @media (max-width: 600px) {
    margin: 2.5rem 3.5rem 0 3.5rem;
  }
`;

const LinkSection = styled(NavLink)`
  width: fit-content;
  margin: 0 1.5rem 0 0;
  font-style: normal;
  font-weight: normal;
  font-size: .81rem;
  line-height: 1rem;
  text-decoration: none;
  color: ${gray600};

  :hover {
    color: ${gray900};
  }

  @media (max-width: 600px) {
    display: block;
    margin-bottom: 1rem;
  }
`;

const SectionContainer = styled.div`
  margin: 2.5rem 12rem;

  @media (max-width: 800px) {
    margin: 4rem 6rem;
  }

  @media (max-width: 600px) {
    margin: 4rem 0;
  }
`;

const Evidences = () => {
  return (
    <ContentFluid>
      <BackHeader/>
      <h1>Evidencias de trabajos</h1>
      <NavContainer>
        {
          UxData.map((item, i) => {
            return <LinkSection key={i} to={item.route} activeClassName='active-link'>{item.section}</LinkSection>;
          })
        }
      </NavContainer>
      <SectionContainer>
        <Switch>
          <Route path="/evidencias/todas" component={AllWorksSection}/>
          <Route path="/evidencias/ux" component={UxSection}/>
          <Route path="/evidencias/creativa" component={CreativeSection}/>
          <Route path="/evidencias/branding" component={BrandingSection}/>
          <Route path="/evidencias/frontend" component={FrontSection}/>
        </Switch>
      </SectionContainer>
    </ContentFluid>
  );
};

export default Evidences;
